<custom-dropdown-list-container [(isDropdownOpen)]="isDropdownOpen" class="has-error-message"
        [ngClass]="{'invalid-input': ngControl.invalid, 'touched-input': ngControl.touched, 'dirty-input': ngControl.dirty}">
    <div class="lookup-box" [class.lookup-highlighted]="isDropdownOpen" [class.invalid-lookup]="ngControl.invalid && ngControl.touched && !isDropdownOpen" dropdown-toggle>
        <div class="custom-box-inner lookup-box-text custom-box-editable">{{displayedText}}</div>
        <div class="lookup-box-arrow-wrapper">
            <i class="custom-arrow down lookup-arrow"></i>
        </div>
    </div>
    <div dropdown-list class="lookup-manager-content">
        <div class="lookup-manager-actions" [class.edit-mode-actions]="currentMode === 'Edit'">
            <div class="lookup-manager-add-action clickable" (click)="toggleMode('Add')" *ngIf="currentMode !== 'Edit'">
                <img src="assets/icons/add_button.svg">
                <div>Create New</div>
            </div>
            <img src="assets/icons/nav-back.svg" class="clickable" *ngIf="currentMode === 'Edit'" (click)="cleanUp()">
            <div class="lookup-manager-edit-action">
                <div class="icon-wrapper" [class.clickable]="currentMode !== 'Edit'" (click)="loadEditMode()">
                    <img src="assets/icons/pencil.svg">
                </div>
                <div *ngIf="currentMode === 'Edit'">Edit</div>
            </div>
        </div>
        <ng-container *ngIf="currentMode === 'Add'" >
            <div>
                <input class="custom-input has-error-message" [class.invalid-input]="itemAlreadyExists(newValue)" [placeholder]="addInputPlaceholder" name="add-input" [(ngModel)]="newValue" autocomplete="off">
                <div *ngIf="itemAlreadyExists(newValue)" class="error-message lookup-error">*{{lookupName}} already exists in list below.</div>
                <div *ngFor="let unsatisfiedRegex of getUnsatisfiedRegexes(newValue)" class="error-message lookup-error">{{unsatisfiedRegex.message}}</div>
            </div>
            <div class="lookup-manager-add-options">
                <button mat-stroked-button class="default-custom-button" (click)="toggleMode('Add')">Cancel</button>
                <button mat-flat-button class="add-button add-lookup" [disabled]="!newValue || itemAlreadyExists(newValue) || getUnsatisfiedRegexes(newValue).length > 0" (click)="addItem(newValue)">Add</button>
            </div>
        </ng-container>
        <div class="lookup-manager-item" *ngFor="let item of items">
            <ng-container  *ngIf="editingItem?.id !== item.id;then selectable_item else editable_item"></ng-container>
            <ng-template #selectable_item>
                <div class="custom-selectable-item lookup-selectable-item" (click)="selectItem(item)">
                    <div class="custom-box-editable">{{item.displayName}}</div>
                    <div *ngIf="currentMode === 'Edit'" class="icon-wrapper" (click)="deleteItem(item);$event.stopPropagation();">
                        <img src="assets/icons/close.svg" class="delete-item-button">
                    </div>
                </div>
            </ng-template>
            <ng-template #editable_item>
                <div class="item-editor-wrapper">
                    <div>
                        <input class="custom-input" placeholder="Enter a category name" name="add-input" [(ngModel)]="editingItem.name" autocomplete="off">
                        <div *ngIf="itemAlreadyExists(editingItem.name) && editingItemNameChanged(editingItem)" class="error-message lookup-error">*{{lookupName}} already exists in list below.</div>
                        <div *ngFor="let unsatisfiedRegex of getUnsatisfiedRegexes(editingItem.name)" class="error-message lookup-error">{{unsatisfiedRegex.message}}</div>
                    </div>
                    <div class="lookup-manager-add-options">
                        <button mat-stroked-button class="default-custom-button" (click)="cancelEdit();$event.stopPropagation();">Cancel</button>
                        <button mat-flat-button class="add-button add-lookup" (click)="editItem(editingItem)"
                            [disabled]="!editingItem.name || itemAlreadyExists(editingItem.name) || !editingItemNameChanged(editingItem) || getUnsatisfiedRegexes(editingItem.name).length > 0">
                            Save
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</custom-dropdown-list-container>
<div class="error-message" *ngIf="ngControl.control.errors && ngControl.touched && !isDropdownOpen" [class.expand-errors]="(ngControl.control.errors ?? {} | keyvalue).length > 1">
    <div *ngFor="let error of (ngControl.control.errors ?? {}) | keyvalue">{{errorMessages[error.key]}}</div>
</div>
